import {
  RECEIVE_ORDER_DATA,
  RECEIVE_ORDER_ERROR_INFO,
  RESET_ORDER_INFO,
  RECEIVE_ORDER_CURRENCY,
  RECEIVE_RETURN_ORDER,
} from '../../actions/orderInfo';

export const initialState = {
  currentOrderNumber: '',
  orderData: {},
  shipByDate: '',
  customerInfo: {},
  orderItems: [],
  validPostalCode: true,
  errorMessage: '',
  errorMessageDetail: '',
  orderLocale: '',
  orderCurrencyCode: '',
  orderCurrencySymbol: '',
  returnOrder: {},
  shipmentList: [],
};

export default (
  state = initialState,
  {
    type,
    data: {
      currentOrderNumber,
      orderData,
      shipByDate,
      customerInfo,
      orderItems,
      validPostalCode,
      errorMessage,
      errorMessageDetail,
      orderLocale,
      orderCurrencyCode,
      orderCurrencySymbol,
      returnOrder,
      shipmentList,
    } = {},
  } = {},
) => {
  switch (type) {
    case RECEIVE_ORDER_DATA:
      return {
        ...state,
        currentOrderNumber,
        orderData,
        shipByDate,
        customerInfo,
        orderItems,
        validPostalCode,
        shipmentList,
      };

    case RECEIVE_ORDER_ERROR_INFO:
      return {
        ...state,
        errorMessage,
        errorMessageDetail,
      };

    case RECEIVE_ORDER_CURRENCY:
      return {
        ...state,
        orderLocale,
        orderCurrencyCode,
        orderCurrencySymbol,
      };

    case RECEIVE_RETURN_ORDER:
      return {
        ...state,
        returnOrder,
      };

    case RESET_ORDER_INFO:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
